module.exports = __webpack_public_path__ + "static/media/so.dc2fb9be.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/so.svg
// module id = 768
// module chunks = 0